import React, { useState, useEffect } from "react";
import styles from "./SlideRecLoader.module.scss";
import starLoader from "img/genai/StarLoader.svg";

const OneByFourLoader = ({ loadingSteps, ismultiloader }) => {
  const [position, setPosition] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);

  // Fast circle rotation
  useEffect(() => {
    const circleInterval = setInterval(() => {
      setPosition((prev) => prev + 1); // spins faster
    }, 250); // circle rotates every 250ms

    return () => clearInterval(circleInterval);
  }, []);

  // Slow text rotation
  useEffect(() => {
    const textInterval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % loadingSteps.length);
    }, 1000); // text changes every 1000ms

    return () => clearInterval(textInterval);
  }, [loadingSteps.length]);

  return (
    <>
      <div
        className={`${styles.progressbox} ${styles.fourloader} ${
          ismultiloader ? styles.noPadding : ""
        }`}
      >
        <div
          className={`${styles.progressIndicator} ${
            ismultiloader ? styles.multiindicater : ""
          }`}
        >
          <div
            className={`${styles.circularProgress} ${
              ismultiloader ? styles.multicircularProgress : ""
            }`}
          >
            <svg viewBox="0 0 36 36">
              <circle
                className={styles.progressBg}
                cx="18"
                cy="18"
                r="15.9155"
                strokeWidth="2"
              />
              <path
                className={styles.progressSegment}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                strokeDasharray="25,90"
                transform={`rotate(${position * 90} 18 18)`} // keeps spinning infinitely
              />
            </svg>
          </div>

          <div className={styles.loadingText}>
            <span>{loadingSteps[currentStep]?.text}</span>
          </div>
        </div>
      </div>

      <span>
        <img
          src={starLoader}
          alt="loader"
          className={`${styles.strloader} ${styles.str} ${styles.stGen}`}
        />
      </span>
    </>
  );
};


export default OneByFourLoader;
